module.exports = __webpack_public_path__ + "static/media/logo-aletheea.b92da3bc.jpg";